import { BaseModel } from "@blue-chip/core";
import SpecCategory from "./SpecCategory";

export default class SpecCategoryDetail extends BaseModel {
  static get belongsTo() {
    return [SpecCategory];
  }
}
